<template>
  <div class="modal fade" id="modalUploadLegalDocument" role="dialog">
    <div class="modal-dialog modal-dialog-centered container-body inter-font">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <div class="change-title">
            <h4 class="modal-title">Upload Legal Documents</h4>
          </div>
          <button type="button" class="close" data-dismiss="modal" @click="resetField">
            &times;
          </button>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="row align-items-start mt-2">
              <div class="col-5 d-flex justify-content-between px-0">
                <div class="px-0">
                  <label class="ol-label">NPWP/SKT</label>
                </div>
                <div>
                  <i
                    class="fa fa-check-circle"
                    aria-hidden="true"
                    style="color: green"
                    v-if="
                      docData['NPWP/SKT'] && docData['NPWP/SKT'].status == 1
                    "
                  ></i>
                  <img
                    src="~@/assets/icon/time.png"
                    style="width: 18px"
                    v-else-if="
                      docData['NPWP/SKT'] && docData['NPWP/SKT'].status == 0
                    "
                  />
                  <img
                    src="~@/assets/icon/remove.png"
                    style="width: 18px"
                    v-else-if="
                      docData['NPWP/SKT'] && docData['NPWP/SKT'].status == 2
                    "
                  />
                  <p class="mb-0 mx-2" style="display: inline-block">:</p>
                </div>
              </div>
              <div class="col-7 pl-1">
                <input
                  class="w-100"
                  type="file"
                  ref="npwpInput"
                  name="npwpSkt"
                  @change="onFileDocPicked($event, 'npwp', 'NPWP')"
                />
              </div>
            </div>
            <div class="row align-items-start mt-2" v-if="npwpFile">
              <div class="col-5 px-0 d-flex justify-content-between mt-2">
                <label class="mb-0">Company Name (NPWP)</label>
                <p class="mb-0 mx-2">:</p>
              </div>
              <div class="col-7 pl-1">
                <div class="d-flex align-items-center w-100">
                  <input
                    type="text"
                    name="companyNameNPWP"
                    v-model="companyNameNPWP"
                    @blur="$v.companyNameNPWP.$touch()"
                    class="form-control flex-grow-1"
                    :style="
                      $v.companyNameNPWP.$error
                        ? 'border: 1px solid red; border-radius:5px'
                        : ''
                    "
                  />
                </div>
                <p
                  v-if="$v.companyNameNPWP.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  Company Name (NPWP) must be filled
                </p>
              </div>
            </div>
            <div class="row align-items-start mt-2" v-if="npwpFile">
              <div class="col-5 px-0 d-flex justify-content-between mt-2">
                <label class="mb-0">NPWP</label>
                <p class="mb-0 mx-2">:</p>
              </div>
              <div class="col-7 pl-1">
                <div class="d-flex align-items-center w-100">
                  <input
                    type="text"
                    name="npwp16"
                    placeholder="0123456789012345 "
                    min="16"
                    max="16"
                    v-model="npwpNumber16"
                    @blur="$v.npwpNumber16.$touch()"
                    class="form-control flex-grow-1"
                    @keypress="isNumber($event)"
                    :style="
                      $v.npwpNumber16.$error
                        ? 'border: 1px solid red; border-radius:5px'
                        : ''
                    "
                  />
                </div>
                <p
                  v-if="$v.npwpNumber16.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  NPWP must be filled and has 16 digits number
                </p>
              </div>
            </div>
            <div class="row align-items-start mt-2" v-if="npwpFile">
              <div class="col-5 px-0 d-flex justify-content-between mt-2">
                <label class="mb-0">NITKU (Jika Ada)</label>
                <p class="mb-0 mx-2">:</p>
              </div>
              <div class="col-7 pl-1">
                <div class="d-flex align-items-center w-100">
                  <input
                    type="text"
                    name="npwp"
                    placeholder="01213456789012345000000"
                    min="22"
                    max="22"
                    v-model="npwpNumber22"
                    @blur="$v.npwpNumber22.$touch()"
                    class="form-control flex-grow-1"
                    @keypress="isNumber($event)"
                    :style="
                      $v.npwpNumber22.$error
                        ? 'border: 1px solid red; border-radius:5px'
                        : ''
                    "
                  />
                </div>
                <p
                  v-if="$v.npwpNumber22.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  NITKU must have 22 digits number
                </p>
              </div>
            </div>
            <div class="row align-items-start mt-2">
              <div class="col-5 d-flex justify-content-between px-0">
                <div class="px-0">
                  <label class="ol-label">SIUP</label>
                </div>
                <div>
                  <i
                    class="fa fa-check-circle"
                    aria-hidden="true"
                    style="color: green"
                    v-if="docData['SIUP'] && docData['SIUP'].status == 1"
                  ></i>
                  <img
                    src="~@/assets/icon/time.png"
                    style="width: 18px"
                    v-else-if="docData['SIUP'] && docData['SIUP'].status == 0"
                  />
                  <img
                    src="~@/assets/icon/remove.png"
                    style="width: 18px"
                    v-else-if="docData['SIUP'] && docData['SIUP'].status == 2"
                  />
                  <p class="mb-0 mx-2" style="display: inline-block">:</p>
                </div>
              </div>
              <div class="col-7 pl-1">
                <input
                  class="w-100"
                  type="file"
                  ref="siupInput"
                  name="siup"
                  @change="onFileDocPicked($event, 'siup', 'SIUP')"
                />
              </div>
            </div>
            <div class="row align-items-start mt-2">
              <div class="col-5 d-flex justify-content-between px-0">
                <div class="px-0">
                  <label class="ol-label">{{(citizenship === "wni"? "KTP": "Passport") + " PIC/Director"}}</label>
                </div>
                <div>
                  <i
                    class="fa fa-check-circle"
                    aria-hidden="true"
                    style="color: green"
                    v-if="docData['KTP'] && docData['KTP'].status == 1"
                  ></i>
                  <img
                    src="~@/assets/icon/time.png"
                    style="width: 18px"
                    v-else-if="docData['KTP'] && docData['KTP'].status == 0"
                  />
                  <img
                    src="~@/assets/icon/remove.png"
                    style="width: 18px"
                    v-else-if="docData['KTP'] && docData['KTP'].status == 2"
                  />
                  <p class="mb-0 mx-2" style="display: inline-block">:</p>
                </div>
              </div>
              <div class="col-7 pl-1">
                <input
                  class="w-100"
                  type="file"
                  ref="ktpInput"
                  name="ktp"
                  @change="onFileDocPicked($event, 'ktp', 'KTPPassport')"
                />
                <p
                  v-if="$v.ktpFile.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  {{(citizenship === "wni"? "KTP": "Passport")}} PIC/Director file must be chosen
                </p>
              </div>
            </div>
            <div class="row align-items-start mt-2">
              <div class="col-5 d-flex justify-content-between px-0">
                <div class="px-0">
                  <label class="ol-label">{{(citizenship === "wni"? "KTP": "Passport")}} Number</label>
                </div>
                <div>
                  <p class="mb-0 mx-2" style="display: inline-block">:</p>
                </div>
              </div>
              <div class="col-7 pl-1">
                <input
                  :style="
                    errorInputKtp
                      ? 'border: 1px solid red; border-radius:5px'
                      : ''
                  "
                  type="text"
                  class="form-control-sm form-control w-100"
                  @input="handleChangeInputKtp"
                  @keypress=" citizenship === 'wni'? isNumber($event):undefined"
                  name="ktpNumber"
                  v-model="ktpNumber"
                />
                <p
                  v-if="errorInputKtp"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  {{citizenship === "wni"? "KTP": "Passport"}} PIC/Director must be filled {{citizenship === "wni"? "and has 16 digits number": ""}}
                </p>
              </div>
            </div>
            <div class="row align-items-start mt-2">
              <div class="col-5 d-flex justify-content-between px-0">
                <div class="px-0">
                  <label class="ol-label">Pilih SK Menkumham </label>
                </div>
                <div>
                  <p class="mb-0 mx-2" style="display: inline-block">:</p>
                </div>
              </div>
              <div class="col-7 pl-1">
                <select
                  class="form-control-sm form-control w-100"
                  name="aktaChoose"
                  id="aktaChoose"
                  v-model="skType"
                >
                  <option value="0">None</option>
                  <option value="1">Pendirian</option>
                  <option value="2">Pendirian & Perubahan</option>
                </select>
              </div>
            </div>
            <div
              class="row align-items-start mt-2"
              v-if="skType == 1 || skType == 2"
            >
              <div class="col-5 d-flex justify-content-between px-0">
                <div class="px-0">
                  <label class="ol-label">Pendirian</label>
                </div>
                <div>
                  <i
                    class="fa fa-check-circle"
                    aria-hidden="true"
                    style="color: green"
                    v-if="
                      docData['SK Menkumham'] &&
                      docData['SK Menkumham'].status == 1
                    "
                  ></i>
                  <img
                    src="~@/assets/icon/time.png"
                    style="width: 18px"
                    v-else-if="
                      docData['SK Menkumham'] &&
                      docData['SK Menkumham'].status == 0
                    "
                  />
                  <img
                    src="~@/assets/icon/remove.png"
                    style="width: 18px"
                    v-else-if="
                      docData['SK Menkumham'] &&
                      docData['SK Menkumham'].status == 2
                    "
                  />
                  <p class="mb-0 mx-2" style="display: inline-block">:</p>
                </div>
              </div>
              <div class="col-7 pl-1">
                <input
                  class="w-100"
                  type="file"
                  ref="skInput"
                  name="sk"
                  @change="onFileDocPicked($event, 'sk', 'SK')"
                />
                <p
                  v-if="$v.skFile.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  SK Menkumham file must be chosen
                </p>
              </div>
            </div>
            <div class="row align-items-start mt-2" v-if="skType == '2'">
              <div class="col-5 d-flex justify-content-between px-0">
                <div class="px-0">
                  <label class="ol-label">Perubahan</label>
                </div>
                <div>
                  <i
                    class="fa fa-check-circle"
                    aria-hidden="true"
                    style="color: green"
                    v-if="
                      docData['SK Menkumham Perubahan'] &&
                      docData['SK Menkumham Perubahan'].status == 1
                    "
                  ></i>
                  <img
                    src="~@/assets/icon/time.png"
                    style="width: 18px"
                    v-else-if="
                      docData['SK Menkumham Perubahan'] &&
                      docData['SK Menkumham Perubahan'].status == 0
                    "
                  />
                  <img
                    src="~@/assets/icon/remove.png"
                    style="width: 18px"
                    v-else-if="
                      docData['SK Menkumham Perubahan'] &&
                      docData['SK Menkumham Perubahan'].status == 2
                    "
                  />
                  <p class="mb-0 mx-2" style="display: inline-block">:</p>
                </div>
              </div>
              <div class="col-7 pl-1">
                <input
                  class="w-100"
                  type="file"
                  ref="skPerubahanInput"
                  name="sk"
                  @change="
                    onFileDocPicked($event, 'skPerubahan', 'SKPerubahan')
                  "
                />
                <p
                  v-if="$v.skPerubahanFile.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  SK Menkumham Perubahan file must be chosen
                </p>
              </div>
            </div>
            <div class="row align-items-start mt-2">
              <div class="col-5 d-flex justify-content-between px-0">
                <div class="px-0">
                  <label class="ol-label">Pilih Akta</label>
                </div>
                <div>
                  <p class="mb-0 mx-2" style="display: inline-block">:</p>
                </div>
              </div>
              <div class="col-7 pl-1">
                <select
                  class="form-control-sm form-control w-100"
                  name="aktaChoose"
                  id="aktaChoose"
                  v-model="aktaType"
                >
                  <option value="0">None</option>
                  <option value="1">Pendirian</option>
                  <option value="2">Pendirian & Perubahan</option>
                </select>
              </div>
            </div>
            <div
              class="row align-items-start mt-2"
              v-if="aktaType == 1 || aktaType == 2"
            >
              <div class="col-5 d-flex justify-content-between px-0">
                <div class="px-0">
                  <label class="ol-label">Pendirian</label>
                </div>
                <div>
                  <i
                    class="fa fa-check-circle"
                    aria-hidden="true"
                    style="color: green"
                    v-if="docData['Akta'] && docData['Akta'].status == 1"
                  ></i>
                  <img
                    src="~@/assets/icon/time.png"
                    style="width: 18px"
                    v-else-if="docData['Akta'] && docData['Akta'].status == 0"
                  />
                  <img
                    src="~@/assets/icon/remove.png"
                    style="width: 18px"
                    v-else-if="docData['Akta'] && docData['Akta'].status == 2"
                  />
                  <p class="mb-0 mx-2" style="display: inline-block">:</p>
                </div>
              </div>
              <div class="col-7 pl-1">
                <input
                  class="w-100"
                  type="file"
                  ref="aktaInput"
                  name="Akta"
                  @change="onFileDocPicked($event, 'akta', 'akta')"
                />
                <p
                  v-if="$v.aktaFile.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  Akta file must be chosen
                </p>
              </div>
            </div>
            <div class="row align-items-start mt-2" v-if="aktaType == 2">
              <div class="col-5 d-flex justify-content-between px-0">
                <div class="px-0">
                  <label class="ol-label">Perubahan</label>
                </div>
                <div>
                  <i
                    class="fa fa-check-circle"
                    aria-hidden="true"
                    style="color: green"
                    v-if="
                      docData['Akta Perubahan'] &&
                      docData['Akta Perubahan'].status == 1
                    "
                  ></i>
                  <img
                    src="~@/assets/icon/time.png"
                    style="width: 18px"
                    v-else-if="
                      docData['Akta Perubahan'] &&
                      docData['Akta Perubahan'].status == 0
                    "
                  />
                  <img
                    src="~@/assets/icon/remove.png"
                    style="width: 18px"
                    v-else-if="
                      docData['Akta Perubahan'] &&
                      docData['Akta Perubahan'].status == 2
                    "
                  />
                  <p class="mb-0 mx-2" style="display: inline-block">:</p>
                </div>
              </div>
              <div class="col-7 pl-1">
                <input
                  class="w-100"
                  type="file"
                  ref="aktaPerubahanInput"
                  name="Akta"
                  @change="
                    onFileDocPicked($event, 'aktaPerubahan', 'aktaPerubahan')
                  "
                />
                <p
                  v-if="$v.aktaPerubahanFile.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  Akta Perubahan file must be chosen
                </p>
              </div>
            </div>
            <div class="row align-items-start mt-2">
              <div class="col-5 d-flex justify-content-between px-0">
                <div class="px-0">
                  <label class="ol-label">Address</label>
                </div>
                <div>
                  <p class="mb-0 mx-2" style="display: inline-block">:</p>
                </div>
              </div>
              <div class="col-7 pl-1">
                <textarea
                  :style="
                    $v.address.$error
                      ? 'border: 1px solid red; border-radius:5px'
                      : ''
                  "
                  @blur="$v.address.$touch()"
                  name="address"
                  id="addressBar"
                  cols="3"
                  rows="4"
                  class="form-control-sm form-control textarea-kyc w-100"
                  v-model="address"
                ></textarea>
                <p
                  v-if="$v.address.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  Address must be filled
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger btn-sm"
            data-dismiss="modal"
            @click="resetField"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm"
            @click="handleSubmit()"
            v-if="isLoadingSubmit == false"
          >
            Yes, Sure
          </button>
          <button type="button" class="btn btn-primary btn-sm" disabled v-else>
            <img src="~@/assets/images/2.gif" style="height: 18px" />Yes, Sure
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  between,
  requiredIf,
} from "vuelidate/lib/validators";

export default {
  props: {
    lesseeData: {
      type: Object,
      required: true,
    },
    newCompany: {
      type: Boolean,
      required: true,
    },
    companyId: {
      type: [String, Number],
      required: true,
    },
    picId: {
      type: [String, Number],
      required: true,
    },
    citizenship: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoadingSubmit: false,
      docData: {},
      errorInputKtp: false,
      adminId: "",
      npwpFile: null,
      siupFile: null,
      ktpFile: null,
      skFile: null,
      skPerubahanFile: null,
      aktaFile: null,
      aktaPerubahanFile: null,
      ktpNumber: "",
      skType: 0,
      aktaType: 0,
      address: "",
      npwpNumber16: "",
      npwpNumber22: "",
      companyNameNPWP: "",
    };
  },
  /**
   * Validation for all fields based on below requirements:
   * - npwpFile is optional, but required if aktaType is 1 or 2 and none of the other files are uploaded
   * - siupFile same as npwpFile
   * - ktpFile is required if npwpFile, skFile, aktaFile is uploaded
   * - skFile is required if skType is 1 or 2
   * - skPerubahanFile is required if skType is 2
   * - aktaFile is required if aktaType is 1 or 2
   * - aktaPerubahanFile is required if aktaType is 2
   * - ktpNumber is required if npwpFile, skFile, aktaFile, ktpFile is uploaded
   * - address is required if any of the files are uploaded except siupFile
   */
  validations: {
    ktpFile: {
      required: requiredIf(function () {
        return (
          this.npwpFile ||
          this.skFile ||
          this.aktaFile ||
          this.aktaType != 0 ||
          this.skType != 0
        );
      }),
    },
    skFile: {
      required: requiredIf(function () {
        return this.skType == 1 || this.skType == 2;
      }),
    },
    skPerubahanFile: {
      required: requiredIf(function () {
        return this.skType == 2;
      }),
    },
    aktaFile: {
      required: requiredIf(function () {
        return this.aktaType == 1 || this.aktaType == 2;
      }),
    },
    aktaPerubahanFile: {
      required: requiredIf(function () {
        return this.aktaType == 2;
      }),
    },
    address: {
      required: requiredIf(function () {
        return (
          this.npwpFile ||
          this.skFile ||
          this.aktaFile ||
          this.aktaType != 0 ||
          this.skType != 0
        );
      }),
    },
    companyNameNPWP: {
      required: requiredIf(function () {
        return this.npwpFile;
      }),
    },
    npwpNumber16: {
      required: requiredIf(function () {
        return this.npwpFile;
      }),
      minLength: minLength(16),
      maxLength: maxLength(16),
    },
    npwpNumber22: {
      minLength: minLength(22),
      maxLength: maxLength(22),
    },
  },
  watch: {
    lesseeData: {
      handler: function (val) {
        if (val.companyDoc && val.companyDoc.length > 0) {
          this.docData = val.companyDoc.reduce((acc, curr) => {
            acc[curr.docType] = curr;
            return acc;
          }, {});
        }
      },
    },
  },
  methods: {
    handleChangeInputKtp(e) {
      const value = e.target.value;
      this.validateInputKTP(value);
    },
    validateInputKTP(value, type) {
      if (
          this.ktpFile ||
          this.npwpFile ||
          this.skFile ||
          this.aktaFile ||
          this.aktaType != 0 ||
          this.skType != 0
        ) {
          if (!value) {
            this.errorInputKtp = true;
            return
          }
          if (this.citizenship === "wni" && value.length != 16) {
            this.errorInputKtp = true;
            return
          }
        }
        if (type != 'submit' && this.citizenship === "wni" && value.length != 16) {
            this.errorInputKtp = true;
            return
          }
        this.errorInputKtp = false;
    },
    resetField() {
      this.ktpFile = null;
      this.skFile = null;
      this.skPerubahanFile = null;
      this.aktaFile = null;
      this.aktaPerubahanFile = null;
      this.ktpNumber = "";
      this.address = "";
      this.npwpNumber16 = "";
      this.npwpNumber22 = "";
      this.skType = 0;
      this.aktaType = 0;
      const allFilesField = [
        "npwp",
        "siup",
        "ktp",
        "sk",
        "skPerubahan",
        "akta",
        "aktaPerubahan",
      ];
      allFilesField.forEach((field) => {
        if (this.$refs[`${field}Input`]) {
          this.$refs[`${field}Input`].value = ''
        }
      });
      this.$v.$reset();
      this.errorInputKtp = false;
    },
    onFileDocPicked(event, type, apiAttName) {
      const file = event.target.files[0];
      if (file) {
        if (file.size > 10 * 1024 * 1024) {
              swal("Sorry", 'File size must be less than 10 MB' , "error", {
                  button: "Ok",
              })
              this.$refs[type+'Input'].value = null;
              return;
          }
        this[`${type}File`] = {
          type: apiAttName,
          docFileName: file.name,
          file: file,
        };
      }
      if (this.$v[`${type}File`]) {
        this.$v[`${type}File`].$touch();
      }
    },
    async handleSubmit() {
      this.$v.$touch();
      const isValid = !this.$v.$invalid;
      this.validateInputKTP(this.ktpNumber, 'submit');
      if (!isValid || this.errorInputKtp) {
        swal("Field Error", "Please check all error field", "error");
        return;
      }
      this.isLoadingSubmit = true;
      const sentData = {
        adminId: this.adminId,
        NPWPFileName: "",
        NPWPBase64: "",
        npwpNumber16:
          this.npwpNumber16 !== null
            ? this.npwpNumber16.replace(this.spaceRegex, " ")
            : this.npwpNumber16,
        npwpNumber22:
          this.npwpNumber22 !== null
            ? this.npwpNumber22.replace(this.spaceRegex, " ")
            : this.npwpNumber22,
        aktaFileName: "",
        aktaBase64: "",
        aktaPerubahanFileName: "",
        aktaPerubahanBase64: "",
        companyAddress:
          this.address !== null
            ? this.address.replace(this.spaceRegex, " ")
            : this.address,
        SIUPFileName: "",
        SIUPBase64: "",
        KTPPassportFileName: "",
        KTPPassportBase64: "",
        ktpPassportNumber:
          this.ktpNumber !== null
            ? this.ktpNumber.replace(this.spaceRegex, " ")
            : this.ktpNumber,
        companyId: this.companyId,
        SKFileName: "",
        SKBase64: "",
        SKPerubahanFileName: "",
        SKPerubahanBase64: "",
        picId: this.picId,
        newCompany: this.newCompany,
        companyNameNPWP:
          this.companyNameNPWP !== null
            ? this.companyNameNPWP.replace(this.spaceRegex, " ")
            : this.companyNameNPWP,
      };
      const allFilesField = [
        { name: "npwpFile", logType: 9, },
        { name: "siupFile", logType: 11 },
        { name: "ktpFile", logType: 12 },
        { name: "skFile", logType: 106 },
        { name: "skPerubahanFile", logType: 0 },
        { name: "aktaFile", logType: 10 },
        { name: "aktaPerubahanFile", logType: 0 },
      ];
      const logsType = [];

      // Convert all files to base64
      const convertedFiles = await Promise.all(
        allFilesField.map(async (field) => {
          if (this[field.name]) {
            const result = {
              ...field
            }
            result.base64String = await this.convertFileToBase64(
              this[field.name].file
            );
            return result;
          }
          return field
        })
      );

      // Assign all files to sentData along with parsing it to base64
      // Also push the logType to logsType array
      convertedFiles.forEach(async (field) => {
        if (field.base64String) {
          sentData[this[field.name].type + "FileName"] = this[
            field.name
          ].docFileName.replace(this.spaceRegex, " ");

          sentData[this[field.name].type + "Base64"] = field.base64String;
          if (field.logType) {
            logsType.push(field.logType);
          }
        }
      });

      try {
        const response = await this.$http.post(process.env.ADD_LEGAL_DOC, sentData, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
          timeout: 180 * 1000,
        })

        if (response.data.status == 200) {
            swal("Success", response.data.message, "success", {
              button: "Ok",
            });
            this.$emit("success-upload-legal-doc", logsType);
            this.resetField();
          }
          if (response.data.status == 201) {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            });
          }
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            }).then(() => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            });
            
          }
          this.isLoadingSubmit = false;
          $("#modalUploadLegalDocument").modal("hide");
        } catch (error) {
            if (error.response && error.response.data) {
              swal("Error", error.response.data.message, "error").then(() => {
                this.isLoadingSubmit = false;
              });
            } else {
              swal("Error", "An unexpected error occurred", "error").then(() => {
                this.isLoadingSubmit = false;
              });
            }
        }

      
    },
    convertFileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => resolve(reader.result.split("base64,")[1]);

        reader.onerror = () => reject(new Error("Failed to read file"));

        reader.readAsDataURL(file); // Convert file to Base64
      });
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem("jwt");
      localStorage.removeItem("admin_name");
      localStorage.removeItem("roles");
      localStorage.removeItem("user_email");
      localStorage.removeItem("admin_id");
      localStorage.removeItem("endrent_cache");
      localStorage.removeItem("changeCatalogPermission");
      this.$router.push("/");
    },
  },
  mounted() {
    this.adminId = localStorage.getItem("admin_id");
  },
};
</script>

<style scoped>
/* Add any styles here if necessary */
@import url("https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap");

.inter-font {
  font-family: "Inter", serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
}

.container-body {
  max-width: 44vw;
}

p,
label,
input,
textarea,
span,
.multiselect {
  color: #2e3646;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/Partnership/Component/ModalKYCLegalDoc.vue